import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "container container-fluid position-relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "navbar-brand"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/main-logo.png",
    alt: "Picado"
  })
], -1)
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarText"
}
const _hoisted_5 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "dropdown nav-m-bar"
}
const _hoisted_8 = {
  class: "nav-link text-dark text-decoration-underline ps-0 text-end",
  type: "button",
  id: "user-profile",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = {
  class: "dropdown-menu shadow border-0 rounded-3 p-4",
  "aria-labelledby": "user-profile",
  style: {"width":"300px"}
}
const _hoisted_10 = { class: "border-bottom-light-grey mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "My Bookings", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold text-center" }, "Do you want to logout?", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("small", { class: "fw-bold" }, "Logout", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "navbar-nav flex-row align-items-center text-end btn-signin"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Login / Sign up")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler me-2",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarText",
  "aria-controls": "navbarText",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["navbar fixed-top navbar-expand-lg", _ctx.nav_name])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "pe-2 nav-item",
                key: item.url
              }, [
                (item.url == '/featured')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: item.url,
                      class: _normalizeClass(["nav-link", _ctx.$route.path == item.url || _ctx.$route.name == 'Featured'? 'active' : ''])
                    }, _toDisplayString(item.title), 11, _hoisted_6))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: item.url,
                      class: _normalizeClass(["nav-link", _ctx.$route.path == item.url || _ctx.$route.matched[0].components.default.name == item.name ? 'active' : ''])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
              ]))
            }), 128))
          ])
        ]),
        (_ctx.$store.getters.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.greatingMsg()) + ", " + _toDisplayString(_ctx.profile ? _ctx.profile.first_name : ''), 1),
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: "/bookings",
                    class: "py-1 w-100 text-black"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _hoisted_12,
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-block py-1 w-100 rounded-3",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                  }, _hoisted_14)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/signin",
                class: "btn btn-primary btn-sm rounded-5 px-3 me-2 fw-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ])),
        _hoisted_17
      ])
    ], 2)
  ]))
}